//OLD CODE, KEPT JUST IN CASE
/*
import undoable from 'redux-undo';
import C_ARTICLE from '../constants/article';

export const drafts = undoable((state = {}, action) => {
    //console.log('state', state);
    //console.log('from reducers', action);
    switch (action.type) {
        case (C_ARTICLE.SAVE_DRAFTS): 
            return {
                ...state,
                ...action.data  
            };
        default:
            return state;
    };
    //return state;
});

//export const undoableDraft = undoable(draft);

//export default undoableDraft;
*/



// WEBPACK FOOTER //
// src/reducers/article.jsx